import { Controller } from "@hotwired/stimulus"

// Toggles "still need this?" into a Yes / Won't Do split button
export default class extends Controller {
  static targets = ["prompt", "choices"]

  expand(event) {
    event.preventDefault()
    this.promptTarget.hidden = true
    this.choicesTarget.hidden = false
    // Listen for clicks outside to collapse
    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) this.collapse()
    }
    document.addEventListener("click", this._outsideClick, true)
  }

  collapse() {
    this.promptTarget.hidden = false
    this.choicesTarget.hidden = true
    if (this._outsideClick) {
      document.removeEventListener("click", this._outsideClick, true)
      this._outsideClick = null
    }
  }

  disconnect() {
    if (this._outsideClick) {
      document.removeEventListener("click", this._outsideClick, true)
    }
  }
}
